import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { COMMA, ENTER, SPACE } from '@angular/cdk/keycodes';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipList } from '@angular/material/chips';
import { Observable, of, Subject, forkJoin } from 'rxjs';
import { debounceTime, exhaustMap, filter, scan, startWith, switchMap, tap } from 'rxjs/operators';
import { ProjectMemberModel } from 'src/app/ViewModel/ProjectMemberModel';
import { TransmittalService } from 'src/app/Service/transmittal-template/transmittal-template.service';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { IProjectElementDetailsOutput } from 'src/app/ViewModel/ProjectElementsModel';
import { CommonService } from 'src/app/Service/Common.service';
import { ITransmittalGroupViewModel, ITransmittalMemberModel, ITransmittalReceiverDetails, IReceiverDetails, ITransmittalDistributionModel, IDistributionDetails, ITransmittalTemplateModel, ITransmittalDistributionViewModel } from 'src/app/ViewModel/TransmittalTemplateModel';
import { groupBy, map, sortBy } from 'lodash';
import { GridComponent } from '@progress/kendo-angular-grid';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { NotificationService } from 'src/app/Service/notification.service';
import { Module } from 'src/app/Service/element-details.data.service';
import { TransmittalTemplateCopyComponent } from '../transmittal-template-copy/transmittal-template-copy.component';

const createFormGroup = (dataItem: ITransmittalGroupViewModel) => new FormGroup({
  'quantity': new FormControl(dataItem.quantity, [Validators.required, Validators.pattern('^[0-9]*$')]),
  'category': new FormControl(dataItem.category, [Validators.required]),
  'type': new FormControl(dataItem.type, [Validators.required]),
  'remarks': new FormControl(dataItem.remarks)
});

const matches = (el: { matches: any; msMatchesSelector: any; }, selector: any) => (el.matches || el.msMatchesSelector).call(el, selector);
@Component({
  selector: 'app-transmittal-template',
  templateUrl: './transmittal-template.component.html',
  styleUrls: ['./transmittal-template.component.css']
})
export class TransmittalTemplateComponent implements OnInit {
  @ViewChild(GridComponent)
  private grid!: GridComponent;
  enableFilter: boolean = false;
  enableFullscreen: boolean = false;
  distributionList: ITransmittalGroupViewModel[] = [];
  separatorKeysCodes: number[] = [ENTER, SPACE, COMMA];
  selectable = true;
  removable = true;
  addOnBlur = true;
  multiple = false;
  selected_Category: any;
  selected_Type: any;
  enablechkLstFullscreen = false;
  projectId!: number;
  groupId!: number;
  memberId!: number;
  editedRowIndex?: number;
  public formGroup?: FormGroup;
  currentEditGroupViewModel?: ITransmittalGroupViewModel;
  transmittalForm!: FormGroup;
  masterMembers: ITransmittalMemberModel[] = [];
  masterMemberIds!: number[];
  ccFilteredMembers!: Observable<ITransmittalMemberModel[]>;
  ccMembers: ITransmittalMemberModel[] = [];
  categoryList: IProjectElementDetailsOutput[] = [];
  copyTypeList: IProjectElementDetailsOutput[] = [];
  distributionGroup: any[] = [];
  templateDetails: ITransmittalTemplateModel[] = [];
  selectedFrom!: number | null;
  selectedTo!: number | null;
  selectedCategory?: number | null;
  template_Id: number | null = null;
  selectedgridCategory!: IProjectElementDetailsOutput;
  selectedgridType!: IProjectElementDetailsOutput;
  @ViewChild('ccInput')
  ccInput!: ElementRef<HTMLInputElement>;
  @ViewChild('ccauto')
  matCcAutoComplete!: MatAutocomplete;
  @ViewChild('ccChipList')
  ccChipList!: MatChipList;
  ccfilter$!: Observable<any>;
  clearTemplateSelected: boolean = false;
  private _nextPage$ = new Subject();

  constructor(private _formBuilder: FormBuilder, private _transmittalService: TransmittalService, private dialog: MatDialog,
    private _projService: ProjectInfoService, private _commonService: CommonService, private renderer: Renderer2, private _notificationService: NotificationService) { }


  ngOnInit() {
    this.projectId = this._commonService.getProjectId();
    this.groupId = this._commonService.getLoggedInUserGroupId();
    this.memberId = this._commonService.getLoggedInUserId();
    this.createForm();
    this.getElementDetails('Message Category');
    this.getElementDetails('Copy Type');
    this._transmittalService.getProjectMembers()?.subscribe((res: ProjectMemberModel[]) => {
      this.masterMembers = res.map(x => {
        let transmittalMember: ITransmittalMemberModel = {
          memberId: x.memberId,
          memberName: x.memberName,
          memberShortName: x.memberShortName,
          eMailId: x.eMailId,
          mobileNo: x.mobileNo,
          staffPSNo: x.staffPSNo,
          groupName: x.memberName + ' - ' + x.groupName,
        };
        return transmittalMember;
      });
      this.masterMemberIds = this.masterMembers.map(x => x.memberId);
      this.ccfilter$ = this.createSerachFilter('ccMembersCtrl');
      this.filterMembers();
      this.getTransmittalDetails();
    })
  }

  private createSerachFilter(formControlName: string): Observable<any> {
    // Note: listen for search text changes
    let x: any = this.transmittalForm.get(formControlName);
    if (x)
      return x.valueChanges.pipe(
        startWith(''),
        debounceTime(200),
        filter(q => typeof q === "string"))
    else return new Observable<any>();
  }

  private createForm(): void {
    this.transmittalForm = this._formBuilder.group({
      template: new FormControl('', [Validators.required]),
      subject: new FormControl('', [Validators.required]),
      quantity: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      category: new FormControl('', Validators.required),
      formCategory: new FormControl('', Validators.required),
      remarks: new FormControl(),
      ccMembersCtrl: new FormControl(),
      ccMembers: [[], [Validators.required, this.validateMemberSelection.bind(this)]],
      fromMember: new FormControl('', Validators.required),
      formFromMember: new FormControl('', Validators.required),
      toMember: new FormControl('', Validators.required),
      formToMember: new FormControl('', Validators.required)
    });
  }

  private filterMembers(): void {
    this.ccFilteredMembers = this.getFilteredMembers(this.ccfilter$);
  }

  private getFilteredMembers(filter$: Observable<any>): Observable<ITransmittalMemberModel[]> {
    return filter$.pipe(
      switchMap(filter => {
        //Note: Reset the page with every new seach text
        let currentPage = 1;
        return this._nextPage$.pipe(
          startWith(currentPage),
          exhaustMap(_ => this.getMembersFake(filter, currentPage)),
          tap((x: any) => currentPage++),
          scan((allMembers, newMembers) => allMembers.concat(newMembers), []),
        );
      }));
  }

  // Fake backend api
  private getMembersFake(startsWith: string, page: number): Observable<ITransmittalMemberModel[]> {
    const take = startsWith == "" ? ((!!this.masterMembers && this.masterMembers.length > 0) ? this.masterMembers.length : 0) : 10;
    const skip = page > 0 ? (page - 1) * take : 0;
    const filtered = this.masterMembers
      .filter((option: any) => option.memberName.toLowerCase().includes(startsWith.toLowerCase()));
    return of(filtered.slice(skip, skip + take));
  }


  optionClicked(event: Event, member: ITransmittalMemberModel, type: string) {
    event.stopPropagation();
    switch (type) {
      case 'cc':
        this.toggleCcSelection(member);
        break;
    }
  }

  toggleCcSelection(member: ITransmittalMemberModel) {


    const index: number = this.ccMembers != null ? this.ccMembers.findIndex(x => x.memberId == member.memberId) : 0;
    if (index > -1) {
      this.ccMembers.splice(index, 1);
      this.ccFormMembers?.value.splice(index, 1);
      this.ccFormMembers?.updateValueAndValidity();
    }
    else {
      this.ccMembers.push(member);
      this.ccFormMembers?.value.push(member);
      this.ccFormMembers?.updateValueAndValidity();
      this.resetCcMemberFilter();
    }
  }

  isMemberSelected(member: ITransmittalMemberModel, type: string): boolean {
    let result: boolean = false;
    switch (type) {
      case 'cc':
        result = this.ccMembers != null ? this.ccMembers.findIndex(x => x.memberId == member.memberId) > -1 : false
        break;
    }
    return result;
  }

  resetCcMemberFilter() {
    this.transmittalForm.get('ccMembersCtrl')?.setValue('');
    this.ccInput.nativeElement.value = '';
    this.ccInput.nativeElement.blur();
  }

  removeCc(member: ITransmittalMemberModel): void {
    const index = this.ccMembers.indexOf(member);
    if (index >= 0) {
      this.ccMembers.splice(index, 1);
      // Remove element from control value array
      this.ccFormMembers?.value.splice(index, 1);
      // where index = index of removed element
      this.ccFormMembers?.updateValueAndValidity();
      this.resetCcMemberFilter();
    }
    if (this.distributionGroup.filter(x => x.receiver_Group == member.groupBy).length > 0) {
      let indexRow = this.distributionGroup.findIndex(x => x.receiver_Group == member.groupBy);
      let index = this.distributionGroup[indexRow].members.findIndex((x: { memberId: number; }) => x.memberId == member.memberId);
      if (this.distributionGroup[indexRow].members.length == 1) {
        this.distributionGroup.splice(indexRow, 1);
      }
      else {
        if (this.distributionGroup[indexRow].members.length > 1) {
          this.distributionGroup[indexRow].members.splice(index, 1);
        }
      }
    }

  }

  // use getter method to access toMembers control value easily
  get toMember(): ITransmittalMemberModel {
    return this.transmittalForm.get('toMember')?.value;
  }

  get ccFormMembers() {
    return this.transmittalForm.get('ccMembers');
  }

  get fromMember(): ITransmittalMemberModel {
    return this.transmittalForm.get('fromMember')?.value;
  }

  onScroll() {
    //Note: This is called multiple times after the scroll has reached the 80% threshold position.
    // this._nextPage$.next();
  }

  validateMemberSelection(abstractControl: AbstractControl): ValidationErrors | null {
    if (abstractControl.touched || abstractControl.dirty) {
      let selectedValue: any[] = abstractControl.value;
      if (!!selectedValue) {
        selectedValue = selectedValue.map(x => x.memberId);
      }
      if (selectedValue && !selectedValue.every(member => this.masterMemberIds.includes(member))) {
        return { IsError: true };
      } else {
        return null;
      }
    }
    else
      return null;
  }

  public getElementDetails(elementName: string) {

    this._projService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.Transmittal, deDescription: elementName })
      .subscribe((res: IProjectElementDetailsOutput[]) => {
        switch (elementName) {
          case "Message Category":
            this.categoryList = res;
            break;
          case "Copy Type":
            this.copyTypeList = res;
            break;
        }
      }, err => { });
  }

  onselectedValueChange(val: any, formGroupName: string, formControlName: string) {
    switch (formGroupName) {
      case "transmittal":
        this.transmittalForm.get(formControlName)?.setValue(val.additionalValues.additionalValues);
        break;
    }

  }

  getGroupByValue(member: ITransmittalMemberModel): number | null | undefined {
    return member.groupBy;
  }

  onGroupByChange(value: number, member: ITransmittalMemberModel) {
    if (typeof Number(value) === "number")
      member.groupBy = value;
    else
      member.groupBy = null;
  }

  showGroupView() {
    if (this.ccMembers.filter(x => !x.groupBy).length > 0) {
      this._notificationService.showPopup("Please enter group by value for all CC members", "Warning");
      return;
    }
    let sortedCcMembers: ITransmittalMemberModel[] = sortBy(this.ccMembers, x => x.groupBy);
    let groupByResult: ITransmittalMemberModel[][] = map(groupBy(sortedCcMembers, x => x.groupBy));
    let existingDistributionList: ITransmittalGroupViewModel[] = this.distributionList;
    this.distributionList = groupByResult.map(x => {
      let groupBy: any = x[0].groupBy;
      let category: any = null;
      let type: any = null;
      let quantity: any = null;
      let remarks: any = "";
      if (!!existingDistributionList && existingDistributionList.length > 0) {
        let groupView: ITransmittalGroupViewModel = existingDistributionList.filter(dl => dl.receiver_Group == x[0].groupBy)[0];
        if (!!groupView) {
          category = groupView.category;
          type = groupView.type;
          quantity = groupView.quantity;
          remarks = groupView.remarks;
        }
      }
      let distributerViewModel: ITransmittalGroupViewModel = {
        receiver_Group: groupBy,
        members: x,
        category: category,
        type: type,
        remarks: remarks,
        quantity: quantity
      };

      return distributerViewModel;
    })
  }


  copy_Transmittal() {
    if (!this.template_Id) {
      this._notificationService.showPopup("Choose Template Name", "Warning");
      return;
    }
    let transmittalData = {
      "project_Id": this.projectId,
      "userId": this.memberId,
      "TransmittalData": this.getTransmittalData,
      "TransmittalReceiverDetails": this.getTransmittalReceiverDetails,
      "DistributionList": this.copyDistribution,
      "TemplateDetails": this.templateDetails
    }
    let dialogRef = this.dialog.open(TransmittalTemplateCopyComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '60%',
      maxWidth: '60vw',
      data: transmittalData
    });
    dialogRef.afterClosed()?.subscribe(data => {
      if (data == true) {
        this.cancelTransmittalTemplate();
        this.template_Id = null;
        this.templateDetails = this.tempTransmital;
        // this.getTransmittalDetails(); 
      }
    });
  }


  getMemberNames(dataItem: ITransmittalMemberModel[]): string {
    return dataItem.map(x => x.memberName).join(' / ');
  }

  getElementType(element: any): string {
    if (!!element && element.length > 0) {
      return element.map((x: { dedShortDescription: string; }) => x.dedShortDescription).toString();
    }
    else {
      return '';
    }
  }

  getElementDesc(element: IProjectElementDetailsOutput): string {
    if (!!element)
      return element.dedShortDescription + ' - ' + element.dedDescription;
    return '';
  }

  /**
 * Element Cell Click Handler
 */
  public cellClickHandler({ isEdited, dataItem, rowIndex }: any): void {
    if (isEdited || (this.formGroup && !this.formGroup.valid)) {
      return;
    }

    this.saveCurrent();
    this.formGroup = createFormGroup(dataItem);
    this.editedRowIndex = rowIndex;
    this.currentEditGroupViewModel = dataItem;
    this.grid.editRow(rowIndex, this.formGroup);
  }

  private saveCurrent(): void {
    if (this.formGroup) {
      if (this.currentEditGroupViewModel) {
        this.currentEditGroupViewModel.type = this.formGroup.get('type')?.value;
        this.currentEditGroupViewModel.category = this.formGroup.get('category')?.value;
        this.currentEditGroupViewModel.quantity = this.formGroup.get('quantity')?.value;
        this.currentEditGroupViewModel.remarks = this.formGroup.get('remarks')?.value;
        if (this.distributionGroup.filter(x => this.currentEditGroupViewModel && x.receiver_Group == this.currentEditGroupViewModel.receiver_Group).length > 0) {
          let index = this.distributionGroup.findIndex(x => this.currentEditGroupViewModel && x.receiver_Group == this.currentEditGroupViewModel.receiver_Group);
          this.distributionGroup.splice(index, 1);
        }
        this.distributionGroup.push(this.currentEditGroupViewModel);
      }
      this.closeEditor();
    }
  }
  /**
   * Close the row editor
   */
  public cancelHandler(): void {
    this.closeEditor();
  }

  private closeEditor(): void {
    this.grid.closeRow(this.editedRowIndex);
    this.editedRowIndex = undefined;
    this.currentEditGroupViewModel = undefined;
    this.formGroup = undefined;
  }



  editRowDynamic(dataItem: any) {
    this.formGroup = createFormGroup(dataItem);
    let rowIndex: any;
    for (let i = 0; i < this.distributionList.length; i++) {
      if (this.distributionList[i].receiver_Group == dataItem.receiver_Group) {
        rowIndex = i;
        break;
      }
    }
    if (this.editedRowIndex && this.editedRowIndex >= 0) {
      this.grid.closeRow(this.editedRowIndex);
    }
    if (!!dataItem.category) {
      this.selected_Category = dataItem.category.dedId;
      this.formGroup.get('category')?.setValue(this.selected_Category);
    }
    if (!!dataItem.type) {
      this.selected_Type = dataItem.type.dedId;
      this.formGroup.get('type')?.setValue(this.selected_Type);
    }
    this.editedRowIndex = rowIndex;
    this.formGroup = createFormGroup(dataItem);
    this.editedRowIndex = rowIndex;
    this.editedRowIndex = rowIndex;
    this.currentEditGroupViewModel = dataItem;
    this.grid.editRow(rowIndex);

  }

  editRowData({ sender, rowIndex, dataItem }: any) {
    //closing previous row, if anything opened
    if (this.editedRowIndex && this.editedRowIndex >= 0) {
      sender.closeRow(this.editedRowIndex);
    }
    this.editedRowIndex = rowIndex;
    this.formGroup = createFormGroup(dataItem);
    this.editedRowIndex = rowIndex;

    if (!!dataItem.category) {
      this.selected_Category = dataItem.category.dedId;
      this.formGroup.get('category')?.setValue(dataItem.category.dedId);
    } else {
      this.selected_Category = null;
      this.formGroup.get('category')?.setValue(null);
    }

    if (!!dataItem.type && dataItem.type.length > 0) {
      this.selected_Type = dataItem.type.map((x: { dedId: any; }) => x.dedId);
      this.formGroup.get('type')?.setValue(this.selected_Type);
    } else {
      this.selected_Type = [];
      this.formGroup.get('type')?.setValue([]);
    }
    this.formGroup.get('quantity')?.setValue(dataItem.quantity);
    this.editedRowIndex = rowIndex;
    this.currentEditGroupViewModel = dataItem;
    sender.editRow(rowIndex);
  }

  UpdateRowData({ sender, rowIndex, dataItem }: any) {
    if (this.formGroup?.valid) {
      this.saveCurrent();
      sender.closeRow(rowIndex);
    } else {
      this._notificationService.showToast('Please Fill all Required Fields', "Error");
    }

  }

  cancelRowData({ sender, rowIndex, dataItem }: any) {
    sender.closeRow(rowIndex);
  }


  onCategoryChange(val: any) {
    if (val.value != '-2') {
      this.formGroup?.get('category')?.setValue(val.additionalValues.additionalValues);
    } else {
      this.formGroup?.get('category')?.setValue(undefined);
    }
  }

  onTypeChange(event: any) {
    if (!!event) {
      if (event.emittingList.length > 0) {
        this.formGroup?.get('type')?.setValue(event.emittingList.map((x: { additionalValues: any; }) => x.additionalValues));
      }
    } else {
      this.formGroup?.get('type')?.setValue(undefined);
    }
  }


  saveTransmittalTemplate() {
    if (!this.transmittalForm.valid) {
      this._notificationService.showPopup("Distribution group details empty.Kindly add the group details", "Warning");
      return;
    }

    let findEmptyfields: any;
    findEmptyfields = this.distributionList.filter((data, index) => {
      if (!data.type || !data.category || !data.quantity) {
        return data;
      }
      return (!data.type || !data.category || !data.quantity)
    });
    if (findEmptyfields.length > 0) {

      this.editRowDynamic(findEmptyfields[0])
    } else {
      if (this.transmittalForm.valid && this.distributionGroup.length > 0) {
        let transmittalDetailsInput: ITransmittalTemplateModel = {
          template_Id: this.template_Id,
          project_Id: this.projectId,
          group_Id: this.groupId,
          template_Name: this.transmittalForm.get("template")?.value,
          template_Subject: this.transmittalForm.get("subject")?.value,
          quantity: this.transmittalForm.get("quantity")?.value,
          template_Remarks: this.transmittalForm.get("remarks")?.value,
          category: this.transmittalForm.get("category")?.value.dedId,
          is_Active: true,
          userId: this.memberId,
        };
        this._transmittalService.InsertUpdateTransmittalDetails(transmittalDetailsInput).subscribe((x: StandardOutputModel) => {
          if (x.successCode == 200) {
            let templateId: number = +x.result;
            let transmittalReceiverDetails = this.saveTransmittalReceiverDetails(templateId);
            let transmittalDistributionDetails = this.saveTransmittalDistributionDetails(templateId);
            forkJoin([transmittalReceiverDetails,
              transmittalDistributionDetails]).subscribe((res: any[]) => {
                this._notificationService.showPopup("Transmittal Template has been saved successfully", "Success")
              })
            //this.getTransmittalDetails();
            this.cancelTransmittalTemplate();
            this.templateDetails = this.tempTransmital;
          }
          else {
            this._notificationService.showPopup(x.successMessage, "Warning");
          }
        })
      }
    }
  }

  private saveTransmittalReceiverDetails(templateId: number) {
    let fromMembers: ITransmittalMemberModel[] = [];
    fromMembers.push(this.fromMember);
    let toMembers: ITransmittalMemberModel[] = [];
    toMembers.push(this.toMember);
    let transmittalReceiverInput: ITransmittalReceiverDetails = {
      template_Id: templateId,
      receiverFromDetails: fromMembers.map(x => {
        let fromMember: IReceiverDetails = {
          member_Id: x.memberId,
          receiver_Type: 1,
          receiver_Group: 0,
          sort_By: 1
        };
        return fromMember;

      }),
      receiverToDetails: toMembers.map(x => {
        let toMember: IReceiverDetails = {
          member_Id: x.memberId,
          receiver_Type: 2,
          receiver_Group: 0,
          sort_By: 1
        };
        return toMember;

      }),
      receiverCcDetails: this.ccMembers.map(x => {
        let ccMember: IReceiverDetails = {
          member_Id: x.memberId,
          receiver_Type: 3,
          receiver_Group: x.groupBy,
          sort_By: 1
        };
        return ccMember;

      }),
      is_Active: true,
      userId: this.memberId

    }
    return this._transmittalService.InsertUpdateTransmittalReceiverDetails(transmittalReceiverInput);
  }

  private saveTransmittalDistributionDetails(templateId: number) {
    let transmittalDistributionInput: ITransmittalDistributionModel = {
      project_Id: this.projectId,
      template_Id: templateId,
      DistributionGroupDetails: this.distributionGroup.map(x => {
        let distDetails: IDistributionDetails = {
          receiver_Group: x.receiver_Group,
          quantity: x.quantity,
          category: x.category.dedId,
          copy_Type: x.type.map((x: { dedShortDescription: any; }) => x.dedShortDescription).toString(),
          remarks: x.remarks
        };
        return distDetails;

      }),
      is_Active: true,
      userId: this.memberId

    }
    return this._transmittalService.InsertUpdateTransmittalDistributionDetails(transmittalDistributionInput);
  }
  tempTransmital: ITransmittalTemplateModel[] = [];
  public getTransmittalDetails() {
    this._transmittalService.GetTransmittalDetails({ project_Id: this.projectId, group_Id: this.groupId })
      .subscribe((res: ITransmittalTemplateModel[]) => {
        this.templateDetails = res;
        this.tempTransmital = res;
      }, err => { });
  }
  getSelected_Type: any[] = [];
  getTransmittalData: any[] = [];
  getTransmittalReceiverDetails: any[] = [];
  copyDistribution: any[] = [];
  changeTransmittalTemplateList(event: { value: any; }) {
    if (event.value != "-2") {
      this.cancelTransmittalTemplate();
      this.templateDetails = this.tempTransmital;
      this.template_Id = event.value;
      this._transmittalService.GetTransmittalDetails({ project_Id: this.projectId, group_Id: this.groupId, template_Id: event.value })
        .subscribe((res: ITransmittalTemplateModel[]) => {
          this.getTransmittalData = res;
          this.transmittalForm.get("template")?.setValue(res[0].template_Name);
          this.transmittalForm.get("subject")?.setValue(res[0].template_Subject);
          this.transmittalForm.get("remarks")?.setValue(res[0].template_Remarks);
          this.transmittalForm.get("quantity")?.setValue(res[0].quantity);
          this.selectedCategory = res[0].category;
          let selValue = this.categoryList.filter(x => this.selectedCategory == x.dedId);
          this.transmittalForm.get("formCategory")?.setValue(selValue[0].dedDescription);
        });
      this._transmittalService.GetTransmittalReceiverDetails({ template_Id: event.value })
        .subscribe((res: ITransmittalReceiverDetails[]) => {
          this.getTransmittalReceiverDetails = res;
          let transmittalReceiverInput: ITransmittalReceiverDetails[] = res;
          let fromMembers: ITransmittalMemberModel[] = this.getTransmittalMembers(transmittalReceiverInput[0].receiverFromDetails);
          if (!!fromMembers && !!fromMembers[0]) {
            this.selectedFrom = fromMembers[0].memberId;
            this.transmittalForm.get("formFromMember")?.setValue(this.selectedFrom);
          }
          let toMembers: ITransmittalMemberModel[] = this.getTransmittalMembers(transmittalReceiverInput[0].receiverToDetails);
          if (!!toMembers && !!toMembers[0]) {
            this.selectedTo = toMembers[0].memberId;

            this.transmittalForm.get("formToMember")?.setValue(this.selectedTo);
          }
          this.ccMembers = this.getTransmittalMembers(transmittalReceiverInput[0].receiverCcDetails);
          if (this.ccMembers != null) {
            this.ccFormMembers?.setValue([...this.ccMembers]);
          }
          this.ccFormMembers?.updateValueAndValidity();
          this.resetCcMemberFilter();

          let sortedCcMembers: ITransmittalMemberModel[] = sortBy(this.ccMembers, x => x.groupBy);
          let groupByResult: ITransmittalMemberModel[][] = map(groupBy(sortedCcMembers, x => x.groupBy));
          this._transmittalService.GetTransmittalDistributionDetails({ template_Id: event.value })
            .subscribe((res: ITransmittalDistributionViewModel[]) => {
              this.copyDistribution = res;
              this.distributionList = res.map(x => {
                this.getSelected_Type = [];
                let selected_type: any[];
                selected_type = x.copy_Type.toString().replace(/-/g, "").split(',');
                for (let i = 0; i < selected_type.length; i++) {
                  for (let j = 0; j < this.copyTypeList.length; j++) {
                    if (selected_type[i] == this.copyTypeList[j].dedShortDescription) {
                      this.getSelected_Type.push(this.copyTypeList[j]);
                    }
                  }
                }
                let distributerViewModel: any = {
                  receiver_Group: x.receiver_Group,
                  members: groupByResult.filter(y => y.filter(z => z.groupBy == x.receiver_Group)[0])[0],
                  category: this.categoryList.filter(y => y.dedId == x.category)[0],

                  type: this.getSelected_Type,
                  remarks: x.remarks,
                  quantity: x.quantity
                };
                return distributerViewModel;
              })

              this.distributionGroup = this.distributionList;
            });
        });

    }
    else {
      this.cancelTransmittalTemplate();
      this.templateDetails = this.tempTransmital;
    }
  }

  private getTransmittalMembers(members: IReceiverDetails[]): ITransmittalMemberModel[] {
    return members.filter(o => this.masterMembers.some(({ memberId }) => o.member_Id === memberId)).map(x => {
      let member: ITransmittalMemberModel = {
        memberId: x.member_Id,
        memberName: x.member_Name,
        memberShortName: this.masterMembers.filter(y => y.memberId == x.member_Id)[0].memberShortName,
        eMailId: this.masterMembers.filter(y => y.memberId == x.member_Id)[0].eMailId,
        staffPSNo: this.masterMembers.filter(y => y.memberId == x.member_Id)[0].staffPSNo,
        mobileNo: this.masterMembers.filter(y => y.memberId == x.member_Id)[0].mobileNo,
        groupBy: x.receiver_Group
      };
      return member;
    });
  }

  cancelTransmittalTemplate() {

    this.distributionList = [];
    this.selectedCategory = null;
    this.selectedFrom = null;
    this.selectedTo = null;
    this.transmittalForm.get("template")?.setValue('');
    this.transmittalForm.get("subject")?.setValue('');
    this.transmittalForm.get("remarks")?.setValue('');
    this.transmittalForm.get("quantity")?.setValue('');
    this.transmittalForm.get("formFromMember")?.setValue('');
    this.transmittalForm.get("formToMember")?.setValue('');
    this.transmittalForm.get("ccMembersCtrl")?.setValue('');
    this.transmittalForm.reset;
    this.ccFormMembers?.setValue([]);
    this.ccMembers = [];
    this.ccFormMembers?.updateValueAndValidity();
    this.resetCcMemberFilter();
  }

  public remarkChange(value: any): void {
    this.formGroup?.get('remarks')?.setValue(value.target.value);
  }

  public qtyChange(value: any): void {
    this.formGroup?.get('quantity')?.setValue(value.target.value);
  }
}
